/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchProject } from "@/services/projectsApi";
import { fetchPages } from "@/services/pagesApi";
import PagesManagement from "../PagesManagement";

export const ProjectPages = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMultiPage, setIsMultiPage] = useState(true);

  useEffect(() => {
    const checkProjectType = async () => {
      if (!projectId) return;

      try {
        const project = await fetchProject(projectId);

        // If single-page project, redirect to builder with home page
        if (project.type === "single") {
          const pages = await fetchPages(projectId);
          const homePage = pages.find(
            (p: any) =>
              p.page_type === "home" || p.title?.toLowerCase() === "home",
          );

          if (homePage) {
            navigate(`/builder/${homePage._id}?projectId=${projectId}`, {
              replace: true,
            });
            return;
          }
        }

        setIsMultiPage(true);
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to check project type:", error);
        setIsLoading(false);
      }
    };

    checkProjectType();
  }, [projectId, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return <PagesManagement projectId={projectId} />;
};
